import { useContext } from "react";
import "../styles/HeroSection.css";
import { ThemeContext } from "../../../../context/ThemeContext";

const HeroSection = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <section className={`hero-section ${theme}`}>
      <div className="hero-carton-bg" aria-hidden="true">
        <svg viewBox="0 0 400 320" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M120 130 L200 60 L280 130 L280 130 L280 250 Q280 262 268 262 L132 262 Q120 262 120 250 Z"
            stroke="currentColor"
            strokeWidth="6"
            strokeLinejoin="round"
          />
          <path d="M120 130 L280 130" stroke="currentColor" strokeWidth="6" />
          <path
            d="M168 78 Q200 30 232 78"
            stroke="currentColor"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path d="M20 150 L64 150" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
          <path d="M8 178 L58 178" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
          <path d="M20 206 L64 206" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
        </svg>
      </div>

      <div className="hero-wrapper">
        <div className="hero-content">
          <h1 className="hero-title">
            Reorder Your Favorite Meals in Under 10 Seconds
          </h1>
          <p className="hero-description">
            Squaay remembers exactly what you love. Save a meal combo
            once, then let smart AI ordering place it again in seconds.
            Or explore new restaurants and vendors near you when you're
            feeling adventurous.
          </p>

          <div className="hero-cta">
            <a
              className="hero-store-btn"
              href="https://play.google.com/store/apps/details?id=com.squaay.android"
            >
              <img
                className="hero-store-btn-icon"
                src="/assets/google-playstore-icon.png"
                alt=""
              />
              <span>Download on Google Play</span>
            </a>
            <a
              className="hero-store-btn"
              href="https://apps.apple.com/app/squaay/id6740501959"
            >
              <img
                className="hero-store-btn-icon"
                src="/assets/apple-icon.png"
                alt=""
              />
              <span>Download on App Store</span>
            </a>
          </div>

          <div className="hero-highlights">
            <span>Order in under 10s</span>
            <span className="hero-highlight-dot">•</span>
            <span>Save your combo once</span>
            <span className="hero-highlight-dot">•</span>
            <span>Discover vendors near you</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
